"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INFO_TEXT = void 0;
const INFO_TEXT = exports.INFO_TEXT = 'info-text';
